/// <reference types="@angular/localize" />

// import { enableProdMode } from '@angular/core';

import './polyfills';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// if(AppModule){
//   enableProdMode();
// } else {
//   console.log('Angular Debug Mode is Enabled');
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
